import { AsyncPipe } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, ViewChild } from '@angular/core';
import { ElementHostComponent } from '@components/element-widgets/element-host/element-host.component';
import { ElementHostOptions, TableType } from '@components/element-widgets/element-host/element-host.options';
import { TableParametersPipe } from '@components/fondsportrait/value-development-table/table-parameters.pipe';
import { TimeFrameSelectionComponent } from '@components/time-frame-selection/time-frame-selection.component';
import { TranslocoModule } from '@ngneat/transloco';
import { ChartBindingDirective } from '@utils/chart-interactive/chart-controller.directive';
import { ChartTimeframeControllerDirective } from '@utils/chart-interactive/chart-timeframe-controller.directive';
import { DataToTimeframePipe } from '@utils/chart-interactive/data-to-timeframe.pipe';
import { TimeframePreselectionDirective } from '@utils/chart-interactive/timeframe-preselection.directive';
import { stockchartPercentualLineOptionsTransformer } from '@utils/charts';
import { HighchartsSizeStrategy } from '@utils/charts/highcharts.directive';
import { LoadingIndicatorDirective } from 'src/app/common/directives/loading-indicator.directive';
import { ElementContentStringPipe } from 'src/app/element-handling/element-content-string.pipe';
import { ElementPipe } from 'src/app/element-handling/element.pipe';
import { ProvideElementsDirective } from 'src/app/element-handling/provide-elements.directive';
import { CUID } from 'src/environments/cuids';

@Component({
  selector: 'rpt-fond-details-content',
  standalone: true,
  imports: [
    TranslocoModule,

    TimeFrameSelectionComponent,
    ElementHostComponent,

    ProvideElementsDirective,
    ChartBindingDirective,
    ChartTimeframeControllerDirective,
    TimeframePreselectionDirective,
    LoadingIndicatorDirective,

    AsyncPipe,
    ElementPipe,
    ElementContentStringPipe,
    DataToTimeframePipe,
    TableParametersPipe,
  ],
  templateUrl: './fond-details-content.component.html',
  styleUrl: './fond-details-content.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FondDetailsContentComponent {
  @Input({ required: true }) public selectedFund!: string;

  @ViewChild('tableRef', { read: ProvideElementsDirective, static: true })
  protected tableProviderElement: ProvideElementsDirective;

  @ViewChild('provider', { read: ProvideElementsDirective, static: true })
  protected chartProvider: ProvideElementsDirective;

  protected readonly tableOptions: ElementHostOptions = { tableType: TableType.SIMPLE };
  protected readonly chartOptions: ElementHostOptions = {
    chartSizeStrategy: HighchartsSizeStrategy.FIT_CONTAINER_HEIGHT,
    chartOptionsTransformer: stockchartPercentualLineOptionsTransformer,
    chartConstructerType: 'stockChart',
  };

  protected readonly boReportIndex: number = 0;
  protected readonly boDocumentId: string = CUID.gesamtbestand.details;
  protected readonly tableElement: string = 'Kennzahlen';
  protected readonly chartElement: string = 'Wertentwicklung';
  protected readonly chartElementBmk: string = 'Wertentwicklung_BMK';
  protected readonly nameElement: string = 'AS-Name';
  protected readonly valueElement: string = 'Fondsvermoegen';
}
